import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ru from "./locales/ru.json";

// react-i18next bootstrap.
//
// Дефолтный язык — `ru`: продукт пишется на русском (документация,
// UI, переписка). `en` — равноправный язык с первого коммита,
// чтобы при подключении англоязычной аудитории не пришлось
// возвращаться и переписывать UI; маркеры в JSX задаются через
// `t("…")`, никаких голых строк (принцип P0).
//
// `escapeValue: false` отключает HTML-эскейпинг интерполяций
// (React сам экранирует выводимые значения), иначе при выводе
// дат с двоеточиями получаются `&#x3A;` в DOM.
//
// `init` возвращает promise, но фактически синхронный (ресурсы в
// памяти, не догружаются с сервера). `void` маркирует, что result
// нас не интересует, и снимает warning от no-floating-promises:
// первый рендер не блокируем, top-level await не нужен.
void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: "ru",
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
});

export { i18n };
